// extracted by mini-css-extract-plugin
module.exports = {"root":"CardLink_root__2UeV0","title":"CardLink_title__28QT3","subTitle":"CardLink_subTitle__1FXtm"};